import React, { FC } from 'react'

import Layout, { LayoutProps } from '../../layouts/Layout'
import { ActionButtonProps } from '../../components/ActionButton'
import { TextareaProps } from '../../components/form/Textarea'

import * as SC from './styled'

export type MessageTemplateProps = {
  className?: string
  layoutProps?: LayoutProps
  title?: string
  text?: string
  textarea: TextareaProps
  successMessage?: string
  back?: {
    label: string
    onClick?: () => void
  }
  confirmButton: ActionButtonProps
}

const MessageTemplate: FC<MessageTemplateProps> = ({
  layoutProps,
  title,
  text,
  textarea,
  successMessage,
  back,
  confirmButton,
}) => {
  return (
    <Layout {...layoutProps}>
      <SC.Content>
        <SC.Box>
          <SC.Title>{title}</SC.Title>
          <SC.Divider />
          <SC.Text>{text}</SC.Text>
          <SC.TextAreaField {...textarea} rows={4} />
          {successMessage && <SC.Success>{successMessage}</SC.Success>}
          <SC.Buttons>
            {back && <SC.Back onClick={back.onClick}>{back.label}</SC.Back>}
            <SC.ConfirmButton {...confirmButton} />
          </SC.Buttons>
        </SC.Box>
      </SC.Content>
    </Layout>
  )
}

export default MessageTemplate
